import request from "@/utils/request";
export function fetchPlaceAreaList(data) {
  return request({
    url: "/whg-park/api/placeArea/list",
    method: "post",
    data: data
  });
}
export function placeCloseList(data) {
  return request({
    url: "/whg-park/api/placeClose/list",
    method: "post",
    data: data
  });
}
export function placeCloseDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: "/whg-park/api/placeClose/delete",
    method: "post",
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: "/whg-park/api/placeClose/insert",
    method: "post",
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: "/whg-park/api/placeClose/update",
    method: "post",
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: "/whg-park/api/placeClose/get",
    method: "post",
    data: data
  });
}